import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface LifetimePartnerFormProps {
  onSuccess?: (reference: string) => void;
}
export const LifetimePartnerForm: React.FC<LifetimePartnerFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-983" data-mp="3adfr97c149qw">
      <div className="mb-6" data-id="element-984" data-mp="3ae8u3x7vaf3r">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-985" data-mp="2wlj31edhejzs">
          Lifetime Partner Access
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-986" data-mp="31jaygidc4o8q">
          Join The Networking Salon as a Lifetime Partner for ₦50,000
          (Discounted from ₦100,000)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-987" data-mp="3tb07jq0q9zzw">
        <div data-id="element-988" data-mp="3t9yw3kfsvbhn">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-989" data-mp="3taqhy3jlhuuq">
            Email <span className="text-gray-500" data-id="element-990" data-mp="3faz4q50wkihs">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-991" data-mp="3k9ivqjucskh0" />
        </div>
        <div data-id="element-992" data-mp="28wzvx2664d9a">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-993" data-mp="28tc0tyl2risg">
            Full Name <span className="text-gray-500" data-id="element-994" data-mp="1ovew8fmbfcru">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-995" data-mp="1ks8n907tj7ho" />
        </div>
        <div data-id="element-996" data-mp="1b02ydzcv566p">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-997" data-mp="162koa5n40kx4">
            Sex <span className="text-gray-500" data-id="element-998" data-mp="160gamvzes7jn">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-999" data-mp="112eryc5waa8p">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-1000" data-mp="x35xf53168c3">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1001" data-mp="s31k1nxf5tq3" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-1002" data-mp="2mhc6jpqjkbsp">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1003" data-mp="2tyhdl5gsrjjl">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1004" data-mp="2yzomj7uoeoru">
            Phone Number <span className="text-gray-500" data-id="element-1005" data-mp="33qeu8rqkr3pp">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-1006" data-mp="33shnrlqxrez6" />
        </div>
        <div data-id="element-1007" data-mp="2g0suo36aimh6">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1008" data-mp="2g0amc86cshsw">
            City of Residence <span className="text-gray-500" data-id="element-1009" data-mp="2kznixkn1138o">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-1010" data-mp="2p18w773h3jje">
            <option value="" data-id="element-1011" data-mp="br5a7e639gl">Select your city</option>
            <option value="Houston Texas" data-id="element-1012" data-mp="4ai18b6wcl24">Houston Texas</option>
            <option value="Lagos" data-id="element-1013" data-mp="2u4bjpa5bq1a">Lagos</option>
            <option value="Abuja" data-id="element-1014" data-mp="2uvuo0mk3vao">Abuja</option>
            <option value="Benin City" data-id="element-1015" data-mp="3u0f5z2knhsjn">Benin City</option>
            <option value="Warri" data-id="element-1016" data-mp="3u1ymmua7y5ly">Warri</option>
            <option value="Berlin" data-id="element-1017" data-mp="csa8dsh3i5za">Berlin</option>
            <option value="Port Harcourt" data-id="element-1018" data-mp="ctv6tt6j692f">Port Harcourt</option>
            <option value="UK" data-id="element-1019" data-mp="7snxhpoqp1tn">UK</option>
            <option value="Other" data-id="element-1020" data-mp="7rmdgvpqx4zs">Other</option>
          </select>
        </div>
        <div data-id="element-1021" data-mp="lrx5i22skpmj">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1022" data-mp="lrdxbd2y1flp">
            Industry <span className="text-gray-500" data-id="element-1023" data-mp="gtcaqi6b6y5h">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-1024" data-mp="vhqgp1z0v2q9" />
        </div>
        <div data-id="element-1025" data-mp="14jpwxs27q2s5">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1026" data-mp="14hdd19cw9icg">
            What do you do? <span className="text-gray-500" data-id="element-1027" data-mp="1j65durdr1b2v">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-1028" data-mp="1j42dbdeyzzjw" />
        </div>
        <div data-id="element-1029" data-mp="1f41yhrnylmcb">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1030" data-mp="1f3iiighvd80x">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-1031" data-mp="156dueb4gr2hh">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1032" data-mp="158grtg7y3xw8">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-1033" data-mp="rgtwpjpqovf1">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1034" data-mp="vft02zvtok4d" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-1035" data-mp="mfcvto7998yg">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1036" data-mp="2jdahliocqplj">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1037" data-mp="2jdjzsk35nsgo">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-1038" data-mp="2abu617lswhfq">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1039" data-mp="3734tny0uka4q">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1040" data-mp="3322ol0k913uu">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1041" data-mp="2y39bh98vjev7" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-1042" data-mp="1mockvux1khlq">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1043" data-mp="17lb38xonw8rd">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1044" data-mp="17luejvjt3ywf">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-1045" data-mp="1hjilrkylmyvh">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-1046" data-mp="1hhe6k6v92dfw" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={50000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-1047" data-mp="1v9ccy9xktv8d" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-1048" data-mp="259cvvurja9c1">
          Complete all required fields to proceed
        </button>}
    </div>;
};